import React from "react";
import Banner from '../Banner/Banner'

import Showcase from '../Showcase/Showcase'


export function MainPage() {
  return (
      <>
        
        <Banner/>
        <Showcase/>
      </>
  );
}
